<div class="input-group">
    <input type="text" class="form-control" floGooglePlacesSearch #loc="ngModel" [placeTypes]="placeTypes"
           [disabled]="disabled" placeholder="Location Search"
           [ngModel]="location.name || location.city || location.zipCode"
           (change)="location.name = $any($event.target).value" [floValidIf]="getValidIf()"
           (placeChange)="onPlaceChange($event)" name="loc">

    <span class="input-group-addon" *ngIf="location?.googlePlaceId">
        <a href="https://www.google.com/maps/place/?q=place_id:{{ location.googlePlaceId }}&t=k" target="_blank">
            <i class="fa fa-map-marker-alt" [popper]="popperLocation" [popperTrigger]="'hover'"></i>
        </a>
        <i class="fas fa-minus-circle pointer" aria-hidden="true" (click)="onClearLocation()" *ngIf="!disabled"
           popper="Clear location" [popperTrigger]="'hover'"></i>
    </span>
</div>

<small class="text-muted pull-xs-right location-format" *ngIf="formatLocation">
    {{location?.format(true)}}
</small>

<flo-invalid-warning [control]="loc" [isSubmitted]="isSubmitted" message="Location is required"></flo-invalid-warning>

<popper-content #popperLocation>
    <span>View Location <i class="fas fa-external-link-alt" aria-hidden="true"></i></span>
</popper-content>
